import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProtoApiService, ProtoResponse } from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { Error } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { ExportType } from '../models/export-type';
import { ListScheduleResultsRequest } from '@lsq-frontend/remote-services/asap-restapi';

interface IListAsapScheduleResultsExportResponse {
    ok: boolean;
    fileString: string;
    error: Error;
}

export class ListAsapScheduleResultsExportResponse
    extends ProtoResponse
    implements IListAsapScheduleResultsExportResponse
{
    public ok = false;
    public fileString = '';
    public error: Error = null;

    constructor(obj?: Partial<IListAsapScheduleResultsExportResponse>) {
        super();
        this.ok = obj?.ok ?? this.ok;
        this.fileString = obj?.fileString ?? this.fileString;
        this.error = obj?.error ?? this.error;
    }
}

export class ListAsapScheduleResultsExportRequest {
    public fileType: string;
    public exportType: ExportType;
    public request: string;

    constructor(init?: Partial<ListAsapScheduleResultsExportRequest>) {
        Object.keys(init ?? {}).forEach((k) => (this[k] = init[k]));
    }
}

@Injectable({ providedIn: 'root' })
export class ListAsapScheduleResultsExportService extends ProtoApiService<
    ListScheduleResultsRequest,
    ListAsapScheduleResultsExportResponse
> {
    public requestType = ListScheduleResultsRequest;
    public responseType = ListAsapScheduleResultsExportResponse;
    public endpointName = 'v1/asapExport';
    public serviceName = 'reportCenter';
    public usePascalForUrl = false;

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }

    public requestMapper(req: ListScheduleResultsRequest): ListAsapScheduleResultsExportRequest {
        const query = JSON.stringify(req);

        return {
            fileType: 'csv',
            exportType: ExportType.ASAP_SCHEDULE_RESULTS,
            request: query
        };
    }

    public get endpointUrl(): string {
        return super.endpointUrl.replace('/api', '');
    }
}
